import { IRSH_QUERY_PARAMS } from '../IrshPages.constants';

export const buildIrshSearchParams = ({
  issueUniqueName,
  reasonName,
}: {
  issueUniqueName?: string;
  reasonName?: string;
}): string => {
  const searchParams = new URLSearchParams();

  if (issueUniqueName) {
    searchParams.set(IRSH_QUERY_PARAMS.ISSUE, issueUniqueName);
  }

  if (reasonName) {
    searchParams.set(IRSH_QUERY_PARAMS.REASON, reasonName);
  }

  const search = searchParams.toString();

  return search ? `?${search}` : '';
};
